import { getPDDomain } from './get-pd-domain.js';

/**
 * @file Cookie convenience function
 *
 * @example
 * cookie() => returns a string with all the cookies (same as document.cookie)
 *
 * @example
 * cookie('name') => returns the value of the cookie 'name' or undefined
 *
 * @example
 * cookie('name', 'value') => sets the value of the cookie 'name' to 'value'
 *
 * @example
 * cookie('name', null) => clears the cookie (sets expiration in the past)
 *
 * @example
 * cookie('name', 'value', {
 *   path: '/',
 *   expires: new Date(Date.now() + 1000*60*60*24*365), // 1 year in ms
 *   domain: 'pagerduty.com',
 *   samesite: 'strict',
 *   secure: true,
 * })
 * All options are optional. There is no error checking, make sure the values
 * are of the right type.
 */

/**
 * @typedef {Object} Options
 * @prop {string} [path]
 * @prop {Date} [expires]
 * @prop {string} [domain]
 * @prop {'strict' | 'lax' | 'none'} [samesite]
 * @prop {boolean} [secure]
 */

/**
 * @arg {string} [name]
 * @arg {string | null} [value]
 * @arg {Options} [options]
 */
export function cookie(name, value, options) {
  const n = arguments.length;
  if (n === 0) return document.cookie;
  if (name != null) {
    return n === 1 ? get(name) : set(name, value, options || {});
  }
}

/** @arg {string} name */
function get(name) {
  name = name.toLowerCase();
  const duc = decodeURIComponent;
  const crumbs = document.cookie.split(';');
  for (let n = crumbs.length; n--; ) {
    const pair = crumbs[n].split('=');
    const key = duc(pair[0].trim().toLowerCase());
    if (name === key) {
      return 1 < pair.length ? duc(pair[1]).trim() : undefined;
    }
  }
  // return undefined;
}

/**
 * @arg {string} name
 * @arg {string | null | undefined} value
 * @arg {Options} opt
 */
function set(name, value, opt) {
  const euc = encodeURIComponent;
  const cookie = [euc(name), '='];

  if (value == null /* or undefined */ || value === '') {
    cookie.push(';expires=', new Date(0).toUTCString());
  } else {
    cookie.push(euc(value));
    if (opt.expires) cookie.push(';expires=', opt.expires.toUTCString());
    if (opt.domain) cookie.push(';domain=', opt.domain);
    if (opt.secure) cookie.push(';secure');
    if (opt.samesite) cookie.push(';samesite=', opt.samesite);
  }
  if (opt.path) cookie.push(';path=', opt.path);

  const str = cookie.join('');
  document.cookie = str;
  return str;
}


export function getURLParam(name) {
  return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.search) || [null, ''])[1].replace(/\+/g, '%20')) || null;
}

export function PDCookieExists(name) {
  if (getPDCookie(name)) {
    return 1
  }
  return 0;
}


export function cookiesAreEnabled() {
  var cookieEnabled = (navigator.cookieEnabled) ? true : false;
  if (typeof navigator.cookieEnabled == "undefined" && !cookieEnabled)
  {
    document.cookie="testcookie";
    cookieEnabled = (document.cookie.indexOf("testcookie") != -1) ? true : false;
  }
  //return true;
  return (cookieEnabled);
}

export function createPDCookie(name, value, days) {
  var cookieDomain = getPDDomain();
  var expires;
  if (days) {
    var date = new Date();
    //date.setTime(date.getTime()+(days*24*60*60*1000));
    date.setTime(date.getTime()+(days*24*60*60*1000));
    expires = "; expires="+date.toGMTString();
  } else {
    expires = "";
  }
  document.cookie = name+"="+value+expires+"; path=/; domain="+cookieDomain;
}

export function getPDCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for(var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

export const getAllCookies = () => {
  var pairs = document.cookie.split(";");
  var cookies = {};
  for (var i=0; i<pairs.length; i++){
    var pair = pairs[i].split("=");
    cookies[(pair[0]+'').trim()] = unescape(pair.slice(1).join('='));
  }
  return cookies;
}